import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getSetting } from '../services/settings.service';
import { useAsync } from '../../shared/hooks/useAsync';

/**
 * Admin-managed HTML for one setting key, already narrowed to the active language.
 *
 * Language is read inside the hook on purpose. The pages this replaces captured
 * it once at module load, so switching to English left the Arabic text on
 * screen until a full reload.
 */
export const useSetting = (settingKey) => {
    const { i18n } = useTranslation();
    const language = i18n.language?.startsWith('ar') ? 'ar' : 'en';

    const task = useCallback(() => getSetting(settingKey), [settingKey]);
    const { data, loading, error, reload } = useAsync(task, [settingKey], null);

    return { html: data?.[language] ?? '', loading, error, reload };
};
